import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import { Button, CircularProgress, IconButton, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import { useCallback, useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { imageCompress } from "../../../../assets/helpers";
import TimesheetSkeletonLoader from "../../shared/components/TimesheetSkeletonLoader";

import {
  DELETE_CLIENT_TIMESHEETS,
  DELETE_CLIENT_TIMESHEET_JOBS,
  DELETE_CLIENT_TIMESHEET_JOB_IMAGES,
  SAVE_CLIENT_TIMESHEETS_NEW,
  SAVE_CLIENT_TIMESHEET_JOB_IMAGES,
  SAVE_CLIENT_UD_FIELDS_VALUES,
  UPDATE_CLOCK_TIME
} from "../../../../constant/Apipath";
import { Fileuploadrequestcall } from "../../../../request/Fileuploadrequest";
import { Postrequestcall } from "../../../../request/Postrequest";
import { ClientEnglishFallback } from "../../../constant/ClientEnglishFallback";
import ConfirmModal from "../../shared/modals/ConfirmModal";
import DeletConfirmModal from "../../shared/modals/DeleteConfirmModal";
import { fetchCrewTimesheet } from "../../view/ViewIndividualTimesheet";
import { JobsListing } from "./ClockInJobRow";
import SelectJobModal from "./ClockInSelectJobs";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

// Define constants
export const VIEWS = {
  LISTING: "LISTING",
  JOBS_SELECT: "JOBS_SELECT"
};

const TIMESHEET_STATUS = {
  IN_REVIEW: "1",
  APPROVED: "2",
  REJECTED: "3",
  IN_PROGRESS: "4"
};

export default function ClientTimesheetClockinComponent({
  FOR,
  modelState,
  reloadData,
  setView,
  view,
  handleClose,
  setModelState,
  InitialTimesheetData,
  setViewClientTimesheetdata
}) {
  // Initialize based on props
  const isIndividualClockin = FOR === "INDIVIDUAL-CLOCKIN";
  const initialView = isIndividualClockin ? VIEWS.LISTING : VIEWS.JOBS_SELECT;
  const initialTimesheetId = isIndividualClockin ? InitialTimesheetData?.id || 0 : 0;

  // Get Redux state
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const {
    ClientEmployeeId: CLIENT_EMPLOYEE_ID,
    ClientId: CLIENT_ID,
    AccentColor: CLIENT_COLOR
  } = selectedClientData;
  const userId = loginData?.userInformation?.UserId;
  const TOKEN = loginData?.accessToken;

  const initialDataRef = useRef(null);
  const [discardDialogOpen, setDiscardDialogOpen] = useState(false);
  const [closeActionType, setCloseActionType] = useState(null);

  // Component state
  const [jobs, setJobs] = useState([]);
  // const [view, setView] = useState(initialView);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPos, setCurrentPos] = useState({ lat: 0, lng: 0 });
  const [timesheetID, setTimesheetID] = useState(initialTimesheetId);
  const [globalDisable, setGlobalDisable] = useState(false);

  // UI state
  const [buttonDisable, setButtonDisable] = useState(false);
  const [confirmSubmit, setConfirmSubmit] = useState(false);
  const [backButtonLoader, setBackButtonLoader] = useState(false);
  const [closeButtonLoader, setCloseButtonLoader] = useState(false);
  const [buttonLoading, setButtonLoading] = useState({ id: 0, num: 0 });

  // Clock in/out state
  const [isPrimary, setIsPrimary] = useState(false);
  const [inProClockIn, setInProcessClockIn] = useState(null);
  const [currentClockOut, setCurrentClockOut] = useState(null);
  const [isClockOutPrompt, setIsClockOutPrompt] = useState(false);
  const [clockinIndex, setClockinIndex] = useState(null);
  const [clockoutIndex, setClockoutIndex] = useState(null);
  // Job deletion state
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteListJobsArray, setDeleteList] = useState({});
  const [imagesDeleteList, setImageDeleteList] = useState([]);
  const [deleteTimesheetModal, setDeleteTimesheetModal] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const [dateForts, setDateForts] = useState(null);
  const [saveLoading, setSaveLoading] = useState(false);
  const [autoClockConfirm, setAutoClockConfirm] = useState(false);

  const {
    TEXT_SUBMIT,
    TEXT_SUBMITTED_TIMESHEET_CANNOT_EDITED,
    TEXT_ADD_JOBS,
    BUTTON_DELETE,
    TEXT_DELETE_HEADER,
    TEXT_JOB_DELETE_TITLE,
    TEXT_CANNOT_BE_UNDONE,
    CLOCK_OUT_CURRENT_JOB,
    TEXT_CONTINUE,
    TEXT_EMP_CLOCKED_IN,
    TEXT_SUBMITTING_AUTOMATTCALLY_CLOCK_OUT_EMP
  } = ClientEnglishFallback?.ConfirmModal(multiLanguageData?.ConfirmModal || {});

  const {
    DISACRD_CHANGES,
    TEXT_WILL_BE_LOST,
    BUTTON_DISCARD,
    BUTTON_SAVE
  } = ClientEnglishFallback?.AddTimesheetModal(multiLanguageData?.AddTimesheetModal || {});

  const WORKPACKAGE_WARNING_TEXT =
    "This timesheet is created using workpackage. You cannot edit this timesheet.";

  useEffect(() => {
    setView(initialView);
  }, []);

  // Check if timesheet is from work package
  useEffect(() => {
    if (InitialTimesheetData?.workPackageId && InitialTimesheetData.workPackageId > 0) {
      setGlobalDisable(true);
    }
  }, [InitialTimesheetData]);

  // Job selection state
  const [selectJobData, setSelectJobData] = useState({ Act: [], jobs1: [] });

  const hasUnsavedChanges = () => {
    if (!initialDataRef.current) return false;
    const initial = initialDataRef.current;
    const current = jobs;

    if (initial.length !== current.length) return true;

    for (let i = 0; i < current.length; i++) {
      const initJob = initial[i];
      const currJob = current[i];

      if ((initJob.notes || "") !== (currJob.notes || "")) return true;

      const initMileage = initJob.timesheetEmployees?.mileage ?? "";
      const currMileage = currJob.timesheetEmployees?.mileage ?? "";
      if (initMileage.toString() !== currMileage.toString()) return true;

      if (JSON.stringify(initJob.udFieldsList || []) !== JSON.stringify(currJob.udFieldsList || [])) return true;
      if (JSON.stringify(initJob.timesheetActivities?.udFieldsList || []) !== JSON.stringify(currJob.timesheetActivities?.udFieldsList || [])) return true;

      let hasNewImages = false;
      currJob.pictureList?.forEach(pic => {
        if (pic.file && (pic.file instanceof File || pic.file instanceof Blob)) hasNewImages = true;
      });
      if (hasNewImages) return true;
    }

    if (imagesDeleteList.length > 0) return true;
    if (Object.keys(deleteListJobsArray).length > 0) return true;

    return false;
  };

  useEffect(() => {
    getLocation();
    if (view === VIEWS.LISTING) {
      fetchTimesheet();
    }
  }, [view]);

  function calculateHoursBetween(startTime, endTime) {
    if (startTime === "00:00" || endTime === "00:00") {
      return "0:00";
    }
    // Convert 12-hour format to 24-hour format
    function convertTo24Hour(timeStr) {
      const [timePart, modifier] = timeStr.split(" ");
      let [hours, minutes] = timePart.split(":").map(Number);

      if (hours === 12) {
        hours = modifier.toLowerCase() === "pm" ? 12 : 0;
      } else if (modifier.toLowerCase() === "pm") {
        hours += 12;
      }

      return { hours, minutes };
    }

    // Parse the input times
    const start = convertTo24Hour(startTime);
    const end = convertTo24Hour(endTime);

    // Calculate difference in minutes
    let diffMinutes = end.hours * 60 + end.minutes - (start.hours * 60 + start.minutes);

    // Handle cases where end time is on the next day
    if (diffMinutes < 0) {
      diffMinutes += 24 * 60; // Add 24 hours in minutes
    }

    // Format the result as HH:MM
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;

    return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
  }

  const getLocation = async () => {
    if (!navigator.geolocation) {
      return { lat: 0, lng: 0 };
    }
    try {
      await navigator.permissions.query({ name: "geolocation" });
      return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const data = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            setCurrentPos(data);
            resolve(data);
          },
          (error) => {
            console.error("getLocation-> Error getting position:", error);
            resolve({ lat: 0, lng: 0 });
          }
        );
      });
    } catch (error) {
      console.error("Permission error:", error);
      return { lat: 0, lng: 0 };
    }
  };

  // Process timesheet data after fetching
  const processTimesheetData = (data, isInitialLoad = false) => {
    let hasOngoingClockin = false;
    let ongoingEntry = null;

    const formattedData = data.map((element, index) => {
      const clockInTime = element.timesheetHours?.clockInTime;
      const clockOutTime = element.timesheetHours?.clockOutTime;
      const isClockIn = clockInTime !== "00:00";
      const isClockOut = clockOutTime !== "00:00";

      if (isClockIn && !isClockOut) {
        hasOngoingClockin = true;
        ongoingEntry = element.timesheetHours;
        setClockoutIndex(index);
      }

      const hours = calculateHoursBetween(clockInTime, clockOutTime);

      return {
        ...element,
        clockinStatus: isClockIn,
        clockoutStatus: isClockOut && isClockIn,
        isPrimary: false,
        totalHours: hours,
        timesheetHours: {
          ...element.timesheetHours,
          hours: hours
        },

        expanded: element.expanded || false
      };
    });

    if (isInitialLoad) {
      initialDataRef.current = JSON.parse(JSON.stringify(formattedData));
    } else if (initialDataRef.current) {
      // Sync clock times into initialDataRef to avoid false positive for unsaved changes
      initialDataRef.current = initialDataRef.current.map((initJob, idx) => {
        if (formattedData[idx]) {
          return {
             ...initJob,
             timesheetHours: {
                ...initJob.timesheetHours,
                clockInTime: formattedData[idx].timesheetHours?.clockInTime,
                clockOutTime: formattedData[idx].timesheetHours?.clockOutTime,
             }
          };
        }
        return initJob;
      });
    }

    setInProcessClockIn(hasOngoingClockin ? ongoingEntry : null);
    setIsPrimary(hasOngoingClockin);
    setJobs(formattedData);
  };
  // Fetch timesheet data
  const fetchTimesheet = async () => {
    setIsLoading(true);
    try {
      const timesheetIdToUse = timesheetID || InitialTimesheetData?.id;
      if (!timesheetIdToUse) {
        console.error("processTimesheetData-> No timesheet ID available");
        return;
      }

      const response = await fetchCrewTimesheet(timesheetIdToUse, userId, TOKEN);
      if (response.status === 200) {
        const existingJobs = jobs || [];

        let workPackageId = response.data.data[0]?.workPackageId;
        setGlobalDisable(workPackageId > 0 ? true : false);
        let fetchedJobs = response.data.data || [];
        let date = response.data.data[0]?.date;
        setDateForts(date);



        const existingJobMap = new Map(existingJobs.map((job) => [job.id, job]));

        const matchedJobs = [];
        const newJobs = [];

        for (const job of fetchedJobs) {
          if (existingJobMap.has(job.id)) {
            const existingJob = existingJobMap.get(job.id);
            matchedJobs.push({
              ...job, // Take latest backend state (e.g. clock times)
              udFieldsList: existingJob.udFieldsList, // Preserve local unsubmitted edits
              timesheetActivities: existingJob.timesheetActivities, // Preserve local unsubmitted activity edits
              timesheetEmployees: existingJob.timesheetEmployees, // Preserve local mileage
              notes: existingJob.notes // Preserve local notes
            });
          } else {
            newJobs.push(job);
          }
        }
        let isInitialLoad = true;
        processTimesheetData([...matchedJobs, ...newJobs], isInitialLoad);
      }
    } catch (error) {
      console.error("Error fetching timesheet:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getudFieldsString = (data) => {
    try {
      if (!data?.length) return "";

      const fieldsObject = data.reduce((acc, item) => {
        acc[item.id] = item.value === "false" ? 0 : 1;
        return acc;
      }, {});

      return JSON.stringify(fieldsObject);
    } catch (error) {
      console.error("Error processing UD fields:", error);
      return "";
    }
  };
  // ===== CLOCK IN/OUT  =====
  const handleClockIn = async (data, index) => {
    if (globalDisable) return;

    if (inProClockIn !== null && isPrimary) {
      setCurrentClockOut(data);
      setClockinIndex(index);
      setIsClockOutPrompt(true);
      return;
    }

    // setButtonDisable(true);
    setButtonLoading({ id: data.id, num: 1 });

    try {
      let data1 = [...jobs];
      data1[index].timesheetHours.clockInTime = moment().format("hh:mm A");
      processTimesheetData(data1);
      const clockInData = [
        {
          Id: data.id,
          Notes: data.notes,
          ModifiedBy: userId,
          ClockOutLatitude: 0,
          ClockOutLongitude: 0,
          ClockOutTime: "00:00",
          ClockInLatitude: currentPos.lat,
          ClockInLongitude: currentPos.lng,
          ClockInTime: moment().format("HH:mm:ss")
        }
      ];

      const timeSheetPayload = {
        UserId: userId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: clockInData
      };

      await Postrequestcall(UPDATE_CLOCK_TIME, timeSheetPayload, TOKEN);
    } catch (error) {
      console.error("handleClockIn-> Clock in error:", error);
    } finally {
      setButtonDisable(false);
      setButtonLoading({ id: 0, num: 0 });
    }
  };

  const handleClockOut = async (data, index) => {
    if (globalDisable) return;

    // setButtonDisable(true);
    setButtonLoading({ id: data.id, num: 2 });
    setIsPrimary(false);

    let data1 = [...jobs];
    data1[index].timesheetHours.clockOutTime = moment().format("h:mm A");
    processTimesheetData(data1);

    try {
      const clockOutData = [
        {
          Id: data.id,
          Notes: data.notes,
          ModifiedBy: userId,
          ClockOutLatitude: currentPos.lat,
          ClockOutLongitude: currentPos.lng,
          ClockInLatitude: data.clockInLatitude,
          ClockOutTime: moment().format("HH:mm:ss"),
          ClockInLongitude: data.clockInLongitude,
          ClockInTime: moment(data.clockInTime, ["hh:mm a", "h:mm A", "HH:mm:ss"]).format("HH:mm:ss")
        }
      ];

      const timeSheetPayload = {
        UserId: userId,
        ReturnRecordId: true,
        SaveList: clockOutData,
        ReturnRecordError: true
      };

      let res = await Postrequestcall(UPDATE_CLOCK_TIME, timeSheetPayload, TOKEN);
      if (res.status === 201) {
        setInProcessClockIn(null);
      }
    } catch (error) {
      console.error("Clock out error:", error);
    } finally {
      setButtonDisable(false);
      setButtonLoading({ id: 0, num: 0 });
    }
  };
  // Handle confirmation to clock out and clock in to another job
  const handleClockOutConfirm = async () => {
    if (!inProClockIn || !currentClockOut) return;

    setButtonDisable(true);
    setIsClockOutPrompt(false);
    setButtonLoading({ id: inProClockIn.id, num: 2 });

    try {
      let data1 = [...jobs];
      data1[clockoutIndex].timesheetHours.clockOutTime = moment().format("h:mm A");
      data1[clockinIndex].timesheetHours.clockInTime = moment().format("h:mm A");
      processTimesheetData(data1);
      const timeSheetPayload = {
        UserId: userId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            ModifiedBy: userId,
            Id: inProClockIn.id,
            Notes: inProClockIn.notes,
            ClockOutLatitude: currentPos.lat,
            ClockOutLongitude: currentPos.lng,
            ClockOutTime: moment().format("HH:mm:ss"),
            ClockInLatitude: inProClockIn.clockInLatitude,
            ClockInLongitude: inProClockIn.clockInLongitude,
            ClockInTime: moment(inProClockIn.clockInTime, ["hh:mm a", "h:mm A", "HH:mm:ss"]).format("HH:mm:ss")
          },
          {
            ModifiedBy: userId,
            ClockOutLatitude: 0,
            ClockOutLongitude: 0,
            ClockOutTime: "00:00",
            Id: currentClockOut.id,
            Notes: currentClockOut.notes,
            ClockInLatitude: currentPos.lat,
            ClockInLongitude: currentPos.lng,
            ClockInTime: moment().format("HH:mm:ss")
          }
        ]
      };

      let res = await Postrequestcall(UPDATE_CLOCK_TIME, timeSheetPayload, TOKEN);

      if (res.status === 201) {
        setCurrentClockOut(null);
      }
    } catch (error) {
      console.error("Clock out confirm error:", error);
    } finally {
      setButtonDisable(false);
      setButtonLoading({ id: 0, num: 0 });
    }
  };

  const handelImageRemove = useCallback(
    (imageIndex, jobIndex, file) => {
      if (file?.id) {
        setImageDeleteList((prev) => [...prev, { Id: file.id }]);
      }
      setJobs((prev) =>
        prev.map((item, idx) =>
          idx === jobIndex
            ? {
              ...item,
              pictureList: item.pictureList.filter((_, i) => i !== imageIndex)
            }
            : item
        )
      );
    },
    [imagesDeleteList]
  );

  const handelExpand = useCallback((index) => {
    setJobs((prev) =>
      prev.map((item, i) => (i === index ? { ...item, expanded: !item?.expanded } : item))
    );
  }, []);

  const handelAddImage = useCallback(async (e, index) => {
    try {
      let files = Array.from(e.target.files);
      files = files.filter((file) => file.type.startsWith("image/"));

      const compressPromises = files.map((file) => imageCompress(file));
      const compressedImages = await Promise.all(compressPromises);

      const newImages = compressedImages.map((img) => ({ file: img }));

      setJobs((prev) =>
        prev.map((item, i) =>
          i === index ? { ...item, pictureList: [...(item.pictureList || []), ...newImages] } : item
        )
      );
    } catch (error) {
      console.error("Error adding images:", error);
    }
  }, []);

  const handelDelete = useCallback(
    (index, item) => {
      if (globalDisable) return;
      if (item?.id) setDeleteList({ Id: item?.id, index: index });
      setDeleteModal(true);
    },
    [globalDisable]
  );

  const handelSelectChange = useCallback((e, index, field) => {
    const updateJobsField = (value) => {
      setJobs((prev) =>
        prev.map((item, i) =>
          i === index
            ? {
              ...item,
              timesheetEmployees: {
                ...item.timesheetEmployees,
                [field]: value
              }
            }
            : item
        )
      );
    };

    if (field === "mileage") {
      const sanitizedText = e.replace(/[^\d.]/g, "").replace(/(\..*)\./g, "$1");

      let formattedMileage = "";

      if (sanitizedText.includes(".")) {
        const [integer, decimal] = sanitizedText.split(".");
        formattedMileage = `${integer.slice(0, 3)}.${decimal.slice(0, 1)}`;
      } else if (sanitizedText?.length <= 3) {
        formattedMileage = sanitizedText;
      } else {
        formattedMileage = `${sanitizedText.slice(0, 3)}.${sanitizedText.slice(3, 4)}`;
      }
      updateJobsField(formattedMileage);
    } else {
      updateJobsField(e);
    }
  }, []);

  const handelNotesChange = useCallback((e, index, field) => {
    setJobs((prev) => prev.map((item, i) => (i === index ? { ...item, [field]: e } : item)));
  }, []);

  // Update user-defined field in activity
  const handelActivityUdFieldChange = useCallback((e, jobIndex, udFieldIndex) => {
    try {
      setJobs((prevJobs) => {
        let Clone = [...prevJobs];

        let newValue = "";
        if (e.target.type === "checkbox") {
          newValue = e.target.checked ? "true" : "false";
        } else {
          newValue = e.target.value;
        }

        Clone[jobIndex].timesheetActivities.udFieldsList[udFieldIndex].value = newValue;

        return Clone;
      });
    } catch (error) {
      console.log(
        "handelActivityUdFieldChange-> Error In Handling Activity UD Field Change: ",
        error
      );
    }
  }, []);

  const handelJobUdFieldChange = useCallback((e, jobIndex, udFieldIndex) => {
    setJobs((prevJobs) =>
      prevJobs.map((job, i) =>
        i !== jobIndex
          ? job
          : {
            ...job,
            udFieldsList: job.udFieldsList.map((item, idx) => {
              if (udFieldIndex === idx) {
                let newValue = "";
                if (e.target.type === "checkbox") {
                  newValue = e.target.checked ? "true" : "false";
                } else {
                  newValue = e.target.value;
                }
                return {
                  ...item,
                  value: newValue
                };
              }
              return item;
            })
          }
      )
    );
  }, []);

  const handelAddJobs = useCallback(() => {
    if (globalDisable) return;

    try {
      const Act = [];
      const jobs1 = [];

      jobs.forEach((item) => {
        jobs1.push({
          clientJobID: item.clientJobId,
          timesheetJobID: item.id
        });

        const actid = item.timesheetActivities?.clientActivityId || 0;
        if (actid !== 0) {
          Act.push({
            actid,
            timesheetJobID: item.id
          });
        }
      });

      setSelectJobData({ Act, jobs1 });
      setView(VIEWS.JOBS_SELECT);
    } catch (error) {
      console.error("handelAddJobs-> Add jobs error:", error);
    }
  }, [jobs, globalDisable, setView]);

  const handelSubmit = async (statusId, closeAction, skip = false) => {
    if (!jobs.length || globalDisable) return;
    setButtonDisable(true);
    if (statusId === 1) setSaveLoading(true);

    try {
      if (statusId === 1 && !autoClockConfirm && !skip) {
        const hasIncomplete = jobs.some((job) => {
          const hr = job.timesheetHoursList?.[0];
          const cin = hr?.clockInTime;
          const cout = hr?.clockOutTime;
          return (
            !hr ||
            !cin ||
            cin === "00:00" ||
            cin === "0:00" ||
            !cout ||
            cout === "00:00" ||
            cout === "0:00"
          );
        });

        if (hasIncomplete) {
          setAutoClockConfirm(true);
          setButtonDisable(false);
          setSaveLoading(false);
          return;
        }
      }

      await handleJobImageDeletions();

      // Save all jobs in a single API call
      const saveResponse = await saveAllJobsData(jobs, statusId);

      if (saveResponse?.status === 201) {
        // Handle image uploads for all jobs using the save response
        await handleAllJobsImageUploads(jobs, saveResponse);
        await handleUDFieldsUpload(jobs, saveResponse);
      }

      await handleDeleteJobs();
    } catch (error) {
      console.error("Submit error:", error);
    } finally {
      finishSubmission(closeAction);
      setTimesheetID(0);
      setConfirmSubmit(false);
      setAutoClockConfirm(false);
      setButtonLoading({ id: 0, num: 0 });
      setSaveLoading(false);
    }
  };

  const handleJobImageDeletions = async (job) => {
    if (imagesDeleteList?.length > 0) {
      const deleteObj = {
        UserId: userId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SoftDelete: false,
        DeleteList: imagesDeleteList
      };

      try {
        await Postrequestcall(DELETE_CLIENT_TIMESHEET_JOB_IMAGES, deleteObj, TOKEN);
      } catch (deleteError) {
        console.error(`Error deleting images for job ${job.clientJobId}:`, deleteError);
      }
    }
  };

  const saveAllJobsData = async (jobs, statusId) => {
    const convertToDecimal = (value) => {
    if (value === null || value === undefined) return 0;
    if (typeof value === "number") return Number(value.toFixed(2));
    const str = String(value);
    return Number(str.replace(":", "."));
  };

    // Create timeSheetJobList with all jobs
    const timeSheetJobList = jobs.map((job) => {
      const hourList = job.timesheetHours || null;
      const empList = job.timesheetEmployees || null;
      const actList = job.timesheetActivities || null;

      return {
        Id: job.id || 0,
        Notes: job.notes || "",
        Deleted: false,
        clockInTime:
          hourList &&
            hourList.clockInTime &&
            hourList.clockInTime !== "00:00" &&
            hourList.clockInTime !== "0:00"
            ? moment(hourList.clockInTime, ["hh:mm a", "h:mm A", "HH:mm:ss"]).format("HH:mm:ss")
            : autoClockConfirm || statusId === 1
              ? moment().format("HH:mm:ss")
              : "00:00",
        clockOutTime:
          hourList &&
            hourList.clockOutTime &&
            hourList.clockOutTime !== "00:00" &&
            hourList.clockOutTime !== "0:00"
            ? moment(hourList.clockOutTime, ["hh:mm a", "h:mm A", "HH:mm:ss"]).format("HH:mm:ss")
            : autoClockConfirm || statusId === 1
              ? moment().format("HH:mm:ss")
              : "00:00",
        ClientJobId: job.clientJobId,
        ClientEmployeeId: empList?.clientEmployeeId || CLIENT_EMPLOYEE_ID,
        ClientJobActivityId: actList?.clientActivityId || 0,
        clockInLatitude: hourList?.clockInLatitude || 0,
        clockOutLatitude: hourList?.clockOutLatitude || 0,
        clockInLongitude: hourList?.clockInLongitude || 0,
        clockOutLongitude: hourList?.clockOutLongitude || 0,
        IsJobUDField: job?.udFieldsList?.length > 0 ? true : false,
        IsEmployeeUDField: false,
        IsActivityUDField: actList?.udFieldsList?.length > 0 ? true : false,
        Mileage: empList?.mileage || 0,
        MileageUnit: empList?.mileageUnit || "km",
        Hours: hourList ? convertToDecimal(hourList.hours) : 0
      };
    });

    const obj = {
      ReturnRecordId: true,
      ReturnRecordError: true,
      SaveList: [
        {
          workPackageId: 0,
          Id: timesheetID || 0,
          dateSubmitted: dayjs().toISOString(),
          Date: new Date(),
          TypeId: 3,
          StatusId: statusId || TIMESHEET_STATUS.IN_REVIEW,
          ClientId: CLIENT_ID,
          Deleted: false,
          timeSheetJobList
        }
      ]
    };

    return await Postrequestcall(SAVE_CLIENT_TIMESHEETS_NEW, obj, TOKEN);
  };

  const handleUDFieldsUpload = async (jobs, saveResponse) => {
    try {
      const resData = saveResponse?.data?.data?.[0]?.objData?.ClientTimesheetJobs || [];
      const timesheetId = saveResponse?.data?.data?.[0]?.objData?.ClientTimesheetId;

      if (!resData.length) return;

      let udSaveList = [];
      jobs.forEach((item) => {
        const activityId = item.timesheetActivities?.clientActivityId || 0;
        const specificID = resData.find((res) =>
          activityId !== 0
            ? res.ClientJobActivityId == activityId && res.ClientJobId === item.clientJobId
            : res.ClientJobActivityId == 0 && res.ClientJobId === item.clientJobId
        );
        if (!specificID) return;

        if (item.udFieldsList?.length > 0) {
          item.udFieldsList.forEach((field) => {
            let valStr = field.value !== undefined ? field.value.toString() : (field.fieldDefaultValue !== undefined ? field.fieldDefaultValue.toString() : "");
            if (valStr.trim() !== "") {
              udSaveList.push({
                Id: item.isUDField ? (field.id || 0) : (field.recordId || 0),
                ClientId: CLIENT_ID,
                ClientEmployeeId: CLIENT_EMPLOYEE_ID,
                AppId: 11,
                AppRecordId: timesheetId,
                AssociatedRecordId: specificID.ClientTimesheetJobId,
                AppEntityId: field.appEntityId || 1,
                EntityRecordId: item.clientJobId,
                UDFieldId: field.udFieldId || field.id,
                Value: valStr,
                ModifiedBy: userId
              });
            }
          });
        }
        if (item.timesheetActivities?.udFieldsList?.length > 0) {
          item.timesheetActivities.udFieldsList.forEach((field) => {
            let valStr = field.value !== undefined ? field.value.toString() : (field.fieldDefaultValue !== undefined ? field.fieldDefaultValue.toString() : "");
            if (valStr.trim() !== "") {
              udSaveList.push({
                Id: item.timesheetActivities.isUDField ? (field.id || 0) : (field.recordId || 0),
                ClientId: CLIENT_ID,
                ClientEmployeeId: CLIENT_EMPLOYEE_ID,
                AppId: 11,
                AppRecordId: timesheetId,
                AssociatedRecordId: specificID.ClientTimesheetJobActivityId || 0, AppEntityId: field.appEntityId || 3,
                EntityRecordId: activityId,
                UDFieldId: field.udFieldId || field.id,
                Value: valStr,
                ModifiedBy: userId
              });
            }
          });
        }
      });

      if (udSaveList.length > 0) {
        const udPayload = {
          UserId: userId,
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: udSaveList
        };
        await Postrequestcall(SAVE_CLIENT_UD_FIELDS_VALUES, udPayload, TOKEN);
      }
    } catch (error) {
      console.error("handleUDFieldsUpload-> Error saving UD fields:", error);
    }
  };

  const handleAllJobsImageUploads = async (jobs, saveResponse) => {
    try {
      const resData = saveResponse?.data?.data?.[0]?.objData?.ClientTimesheetJobs || [];
      const timesheetId = saveResponse?.data?.data?.[0]?.objData?.ClientTimesheetId;

      if (!resData.length) {
        console.warn("No saved jobs data available for image upload");
        return;
      }

      const imagePromises = jobs.flatMap((item) => {
        const pictureList = item?.pictureList || [];
        if (!pictureList.length) return [];

        const activityId = item.timesheetActivities?.clientActivityId || 0;

        const specificID = resData.find((res) =>
          activityId !== 0
            ? res.ClientJobActivityId == activityId && res.ClientJobId === item.clientJobId
            : res.ClientJobActivityId == 0 && res.ClientJobId === item.clientJobId
        );

        if (!specificID) return [];

        return pictureList.map((file) => {
          const formData = new FormData();
          formData.append("Id", 0);
          formData.append("ClientActivityId", specificID.ClientJobActivityId);
          formData.append("FileName", file.file);
          formData.append("ModifiedBy", loginData?.userInformation?.UserId);
          formData.append("ClientTimesheetJobId", specificID.ClientTimesheetJobId);
          formData.append("ClientTimesheetId", timesheetId);
          formData.append("ClientJobId", specificID.ClientJobId);

          return Fileuploadrequestcall(
            SAVE_CLIENT_TIMESHEET_JOB_IMAGES,
            formData,
            loginData?.accessToken
          );
        });
      });

      if (imagePromises.length > 0) {
        await Promise.all(imagePromises);
      }
    } catch (error) {
      console.error("handleAllJobsImageUploads-> Error: ", error);
    }
  };

  // Finish submission process
  const finishSubmission = (closeAction) => {
    clearData();
    setDeleteModal(false);
    setButtonDisable(false);
    setBackButtonLoader(false);
    setCloseButtonLoader(false);
    setButtonLoading({ id: 0, num: 0 });

    if (closeAction === "CLOSE") {
      reloadData();
      setViewClientTimesheetdata(null);
      setDeleteTimesheetModal(false);
      setDeleteList({});
      setImageDeleteList([]);
      setJobs([]);
      setIsPrimary(false);
      setInProcessClockIn(null);
      setCurrentClockOut(null);
      setIsClockOutPrompt(false);
      setSelectJobData({ Act: [], jobs1: [] });
      setTimesheetID(0);
      setView(VIEWS.JOBS_SELECT);
      setButtonDisable(false);
      setButtonLoading({ id: 0, num: 0 });
      setDeleteModal(false);
      handleClose();
      setModelState("HOME");
    }
    if (closeAction === "BACK") setModelState("HOME");
  };

  // Delete timesheet
  const deleteTimesheet = async (id) => {
    if (!id) return;
    try {
      setDeleteLoading(true);
      const obj = {
        userId: userId,
        returnRecordError: true,
        softDelete: false,
        deleteList: [{ id: Number(id) }]
      };

      const res = await Postrequestcall(DELETE_CLIENT_TIMESHEETS, obj, TOKEN);

      if (res.status === 201) {
        clearData();
        handleClose();
        reloadData();
        setModelState("HOME");
        setDeleteTimesheetModal(false);
      }
    } catch (error) {
      console.error("Delete timesheet error:", error);
    } finally {
      setDeleteLoading(false);
    }
  };

  // Delete jobs
  const handleDeleteJobs = async () => {
    if (deleteListJobsArray?.Id) {
      try {
        setDeleteLoading(true);
        const deleteObj = {
          UserId: userId,
          ReturnRecordId: true,
          ReturnRecordError: true,
          SoftDelete: false,
          DeleteList: [{ Id: deleteListJobsArray?.Id }]
        };

        const res = await Postrequestcall(DELETE_CLIENT_TIMESHEET_JOBS, deleteObj, TOKEN);

        if (res.status === 201) {
          let data = [...jobs];
          data = data.filter((item, index) => index !== deleteListJobsArray?.index);
          setDeleteList({});
          processTimesheetData(data);
          setDeleteModal(false);
          setDeleteList({});
        }
      } catch (error) {
        console.error("Delete jobs error:", error);
      } finally {
        setDeleteLoading(false);
      }
    }
  };

  // Clear all data
  const clearData = () => {
    setJobs([]);
    setDeleteList({});
    setIsPrimary(false);
    setImageDeleteList([]);
    setCurrentClockOut(null);
    setInProcessClockIn(null);
    setIsClockOutPrompt(false);
    setSelectJobData({ Act: [], jobs1: [] });
  };

  // Handle back button action
  const handleBackAction = () => {
    if (view === VIEWS.JOBS_SELECT) {
      clearData();
      setTimesheetID(0);
      setModelState("HOME");
      setViewClientTimesheetdata(null);
      if (reloadData) reloadData();
      return;
    }

    if (jobs.length === 0) {
      setView(VIEWS.JOBS_SELECT);
      return;
    }

    if (hasUnsavedChanges()) {
      setCloseActionType("BACK");
      setDiscardDialogOpen(true);
    } else {
      clearData();
      setTimesheetID(0);
      setModelState("HOME");
      setViewClientTimesheetdata(null);
      if (reloadData) reloadData();
    }
  };

  // Handle close button action
  const handleCloseAction = () => {
    // If globally disabled, close directly without saving
    if (globalDisable) {
      clearData();
      handleClose();
      setModelState("HOME");
      if (isIndividualClockin) {
        reloadData();
      }
      return;
    }

    if (view === VIEWS.JOBS_SELECT || jobs.length === 0) {
      clearData();
      handleClose();
      setModelState("HOME");
      setViewClientTimesheetdata(null);
      if (isIndividualClockin) {
        reloadData();
      }
      return;
    }

    if (hasUnsavedChanges()) {
      setCloseActionType("CLOSE");
      setDiscardDialogOpen(true);
    } else {
      clearData();
      handleClose();
      setModelState("HOME");
      reloadData();
    }
  };

  const handelMileageBlur = useCallback((index, value) => {
    try {
      if (value === "" || value == undefined) return;

      const sanitizedText = value.replace(/[^\d.]/g, "").replace(/(\..*)\./g, "$1");

      let formattedMileage = "";

      if (sanitizedText.includes(".")) {
        const [integer, decimal] = sanitizedText.split(".");
        formattedMileage = `${integer.slice(0, 3)}.${decimal.slice(0, 1)}`;
      } else if (sanitizedText?.length <= 3) {
        formattedMileage = sanitizedText;
      } else {
        formattedMileage = `${sanitizedText.slice(0, 3)}.${sanitizedText.slice(3, 4)}`;
      }

      setJobs((prev) => {
        let Clone = [...prev];

        Clone[index].timesheetEmployees.mileage = formattedMileage || "0";

        return Clone;
      });
    } catch (error) {
      console.log("handelMileageBlur-> Error When Handling Mileage Blur: ", error);
    }
  }, []);

  return (
    <>
      <Dialog open={discardDialogOpen} onClose={() => setDiscardDialogOpen(false)}>
        <DialogTitle>{DISACRD_CHANGES}</DialogTitle>
        <DialogContent>{TEXT_WILL_BE_LOST}</DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setDiscardDialogOpen(false);
              if (closeActionType === "CLOSE") {
                clearData();
                handleClose();
                setModelState("HOME");
                reloadData();
              } else if (closeActionType === "BACK") {
                clearData();
                setTimesheetID(0);
                setModelState("HOME");
                setViewClientTimesheetdata(null);
                reloadData();
              }
            }}
            sx={{
              boxShadow: "none",
              color: "#000",
              textTransform: "none",
              borderRadius: "8px",
              width: "100px"
            }}>
            {BUTTON_DISCARD}
          </Button>
          <Button
            onClick={() => {
              setDiscardDialogOpen(false);
              if (closeActionType === "CLOSE") {
                setTimesheetID(0);
                handelSubmit(4, "CLOSE");
                setCloseButtonLoader(true);
              } else {
                handelSubmit(4, "BACK");
                setBackButtonLoader(true);
              }
            }}
            color="primary"
            variant="contained"
            sx={{
              boxShadow: "none",
              color: "white",
              backgroundColor: CLIENT_COLOR,
              textTransform: "none",
              borderRadius: "8px",
              width: "100px"
            }}>
            {BUTTON_SAVE}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Confirm modal for clock out */}
      <ConfirmModal
        isOpen={isClockOutPrompt}
        isHelpModal={false}
        title={CLOCK_OUT_CURRENT_JOB}
        confirmButtonText={TEXT_CONTINUE}
        onClose={() => {
          setCurrentClockOut(null);
          setIsClockOutPrompt(false);
        }}
        onConfirm={handleClockOutConfirm}
      />

      {/* confirm For submit } */}
      <ConfirmModal
        isOpen={confirmSubmit}
        confirmButtonText={TEXT_SUBMIT}
        title={TEXT_SUBMITTED_TIMESHEET_CANNOT_EDITED}
        onClose={() => {
          setConfirmSubmit(false);
        }}
        onConfirm={() => {
          handelSubmit(1, "CLOSE", true);
          setConfirmSubmit(false);
        }}
      />

      {/* confirm For auto clock in/out on submit */}
      <ConfirmModal
        confirmButtonText={TEXT_CONTINUE}
        isOpen={autoClockConfirm}
        title={
          <Stack>
            <Typography variant="h6" sx={{ color: "#000" }}>
              {TEXT_EMP_CLOCKED_IN}
            </Typography>
            <Typography sx={{ fontSize: "14px" }}>
              {TEXT_SUBMITTING_AUTOMATTCALLY_CLOCK_OUT_EMP}
            </Typography>
          </Stack>
        }
        onConfirm={() => {
          handelSubmit(1, "CLOSE");
          setAutoClockConfirm(false);
        }}
        onClose={() => {
          setAutoClockConfirm(false);
        }}
      />

      {/* Header with back and close buttons */}
      <Stack
        sx={{ display: "flex",  mb: 1,  alignItems: "center", justifyContent: "space-between" }}   direction="row">
        {modelState !== "HOME" && !globalDisable && !isIndividualClockin && (
          <IconButton
            size="small"
            loading={backButtonLoader}
            disabled={buttonDisable || globalDisable || isLoading}
            onClick={handleBackAction}
            loadingIndicator={<CircularProgress sx={{ color: CLIENT_COLOR }} size={20} />}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <IconButton
          size="small"
          disabled={buttonDisable}
          style={{ padding: "4px" }}
          loading={closeButtonLoader}
          onClick={handleCloseAction}
          loadingIndicator={<CircularProgress sx={{ color: CLIENT_COLOR }} size={20} />}>
          <CloseIcon />
        </IconButton>
      </Stack>

      {/* Job selection view */}
      {view === VIEWS.JOBS_SELECT && (
        <SelectJobModal
          setView={setView}
          setList={setJobs}
          modelState={modelState}
          timeSheetId={timesheetID}
          selectJobData={selectJobData}
          setTimesheetID={setTimesheetID}
          setSelectJobData={setSelectJobData}
        />
      )}

      {/* Job listing view */}
      {view === VIEWS.LISTING && (
        <>
          {/* Warning message for work package timesheets */}
          {globalDisable && (
            <Stack
              sx={{
                p: 1,
                mb: 2,
                borderRadius: "8px",
                backgroundColor: "#fff3cd",
                border: "1px solid #ffeaa7",
                alignItems: "center"
              }}>
              <Typography
                variant="body2"
                sx={{
                  color: "#856404",
                  fontWeight: 500,
                  textAlign: "center"
                }}>
                {WORKPACKAGE_WARNING_TEXT}
              </Typography>
            </Stack>
          )}

          {isLoading && jobs.length === 0 ? (
            <TimesheetSkeletonLoader variant="jobList" />
          ) : (
            <Stack sx={{ gap: 1 }} >
              {/* Job list */}
              <Stack
                spacing={1}
                sx={{
                  display: "flex",
                  overflowY: "auto",
                  maxHeight: "500px",
                  scrollbarWidth: "none",
                  flexDirection: "column"
                }}>
                {dateForts && (
                  <Typography
                    sx={{ marginBottom: 1,  fontWeight: 500 }}
                    style={{
                      fontSize: "18px"
                    }}
                    >
                    {moment(dateForts).format("MMMM DD, YYYY")}
                  </Typography>
                )}
                {jobs?.map((item, index) => (
                  <JobsListing
                    key={index}
                    item={item}
                    index={index}
                    isPrimary={isPrimary}
                    loading={buttonLoading}
                    CLIENT_COLOR={CLIENT_COLOR}
                    handelExpand={handelExpand}
                    handelDelete={handelDelete}
                    globalDisable={globalDisable}
                    buttonDisable={buttonDisable}
                    handelClockIn={handleClockIn}
                    handelAddImage={handelAddImage}
                    handelClockOut={handleClockOut}
                    handelNotesChange={handelNotesChange}
                    handelImageRemove={handelImageRemove}
                    handelMileageBlur={handelMileageBlur}
                    handelSelectChange={handelSelectChange}
                    handelJobUdFieldChange={handelJobUdFieldChange}
                    handelActivityUdFieldChange={handelActivityUdFieldChange}
                  />
                ))}

                {/* Add jobs button */}
                <Button
                  sx={{
                    bgcolor: "white",
                    color: CLIENT_COLOR,
                    borderRadius: "10px",
                    textTransform: "none"
                  }}
                  disabled={globalDisable}
                  onClick={handelAddJobs}>
                  {TEXT_ADD_JOBS}
                </Button>
              </Stack>

              {/* Action buttons */}
              <Stack sx={{ gap: 1 }} direction="row" >
                <Button
                  fullWidth
                  disabled={buttonDisable || globalDisable}
                  onClick={() => {
                    setDeleteTimesheetModal(true);
                  }}
                  sx={{
                    color: "black",
                    bgcolor: "white",
                    borderRadius: "10px",
                    textTransform: "none",
                    boxShadow: "none"
                  }}>
                  {BUTTON_DELETE}
                </Button>
                <LoadingButton
                  onClick={() => setConfirmSubmit(true)}
                  fullWidth
                  variant="contained"
                  startIcon={<></>}
                  loadingPosition="start"
                  loading={saveLoading}
                  disabled={jobs?.length === 0 || globalDisable}
                  sx={{
                    color: "white",
                    borderRadius: "10px",
                    boxShadow: "none",
                    textTransform: "none",
                    bgcolor: jobs?.length === 0 || globalDisable ? "lightgray" : CLIENT_COLOR
                  }}>
                  {TEXT_SUBMIT}
                </LoadingButton>
              </Stack>
            </Stack>
          )}
        </>
      )}

      {/* Delete confirmation modal */}

      <DeletConfirmModal
        loading={deleteLoading}
        onConfirm={() => {
          if (deleteTimesheetModal) {
            deleteTimesheet(timesheetID);
          } else {
            handleDeleteJobs();
          }
        }}
        heading={deleteTimesheetModal ? TEXT_DELETE_HEADER : TEXT_JOB_DELETE_TITLE}
        title={TEXT_CANNOT_BE_UNDONE}
        isOpen={deleteModal || deleteTimesheetModal}
        onClose={() => {
          setDeleteList({});
          setDeleteModal(false);
          setDeleteTimesheetModal(false);
        }}
      />
    </>
  );
}

